<script lang="ts">
    import { REWARDS_REWARD_TYPES } from "@apps/rewards/constants/rewardsRewardTypes";
    import type RewardsCustomerActiveRewardsQuery from "@apps/rewards/modules/CustomerRewards/queries/RewardsCustomerActiveRewardsQuery";
    import type RewardsCustomerRewardsService from "@apps/rewards/modules/CustomerRewards/services/RewardsCustomerRewardsService";
    import { getCustomerActiveRewardsInfo } from "@apps/rewards/modules/CustomerRewards/utils";
    import { lastValueFrom } from "rxjs";
    import { onMount } from "svelte";

    import Dropdown from "@components/forms/Select/Dropdown.svelte";

    import type { SelectedDiscountValue } from "./types";

    //Props
    export let customerRewardsService: RewardsCustomerRewardsService;
    export let customerActiveRewardsQuery: RewardsCustomerActiveRewardsQuery;
    export let locale: string;
    export let onChange: (value: SelectedDiscountValue) => void;

    const customerActiveRewardsList$ =
        customerActiveRewardsQuery.customerActiveRewardsList$;

    let selectedValue: SelectedDiscountValue = {
        itemId: 0,
        type: REWARDS_REWARD_TYPES.giftCard,
        code: "",
    };

    const handleChange = (id: number) => {
        let item = $customerActiveRewardsList$.find((item) => item.id === id);

        if (item?.reward.type === REWARDS_REWARD_TYPES.giftCard) {
            selectedValue = {
                itemId: item.id,
                type: item.reward.type,
                code: item.reward.code,
            };
        }

        if (item?.reward.type === REWARDS_REWARD_TYPES.freeProduct) {
            selectedValue = {
                itemId: item.id,
                type: item.reward.type,
                code: item.reward.discountCode,
                variantId: item.reward.variantId,
            };
        }

        if (item?.reward.type === REWARDS_REWARD_TYPES.discount) {
            selectedValue = {
                itemId: item.id,
                type: item.reward.type,
                code: item.reward.discountCode,
            };
        }

        onChange(selectedValue);
    };

    onMount(() =>
        lastValueFrom(
            customerRewardsService.getCustomerActiveRewards({
                locale,
            })
        )
    );
</script>

<Dropdown
    placeholderText="Choose discount"
    items={$customerActiveRewardsList$.map((item) =>
        getCustomerActiveRewardsInfo(item)
    )}
    value={selectedValue.itemId}
    inputAttributes={{ name: "select" }}
    on:change={(e) => handleChange(e.detail.value)}
/>
